// removed by extract-text-webpack-plugin
module.exports = {"linkText":"App__linkText___33iYg"};